import { Modal } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import { ReactNode } from 'react';

import { useModal } from '../Context';
import s from './styles.module.scss';

type ModalWrapperProps = {
  children: ReactNode;
  className?: string;
  allowEscClose?: boolean;
};

export function ModalWrapper({
  children,
  className,
  allowEscClose = true,
}: ModalWrapperProps): JSX.Element | null {
  const { hideModal } = useModal();
  return (
    <Modal
      allowEscClose={allowEscClose}
      className={cx(s['modalBody'], className)}
      isOpen
      onClose={hideModal}
    >
      {children}
    </Modal>
  );
}
